
export default {
  name: 'ErrorIcon'
}
